import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import {
  Box,
  VStack,
  Collapse,
  Button,
  Tooltip,
  Input,
  Text,
  Flex,
} from "@chakra-ui/react";
import { toast } from "react-toastify";
import { getSectorCategories, getAllSectors } from "../../actions/sector/sectorActions";
import "./LeftSidebar.scss";
import search from "../../assets/images/search.png";

const LeftSidebar = (props) => {
  const { sectorId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isAuthenticatedUser } = useSelector((state) => state.userReducer);

  const {
    categories = [], // 6 industries from API
    categoriesLoading = false,
    data: products = [], // products for selected industry
    loading: productsLoading = false,
  } = useSelector((state) => state.sectorSmmReducer);

  const [industryImage, setIndustryImage] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [isOpen, setIsOpen] = useState(true);
  const [expandedIndustry, setExpandedIndustry] = useState(null);

  // fetch industry categories
  useEffect(() => {
    dispatch(getSectorCategories());
  }, [dispatch]);

  // when industry clicked → expand and load products
  const handleIndustryClick = (categoryName) => {
    if (expandedIndustry === categoryName) {
      setExpandedIndustry(null);
    } else {
      setExpandedIndustry(categoryName);
      dispatch(getAllSectors(categoryName));
    }
  };

  const toggleSidebar = () => setIsOpen(!isOpen);

  const addClientButtonHandler = () => {
    toast.error("You will receive an update shortly", { position: "top-center" });
  };

  const handleProductClick = (productName) => {
    if (props.onClose) props.onClose();
    navigate(`/product/${productName}`);
  };

  return (
    <Box className="left-menu-container">
      <VStack align="start" className="left-menu">
        {/* Header */}
        <Box className="navigation-label-industry search-container">
          {industryImage && (
            <Box
              className="search-box"
              style={{ cursor: "pointer" }}
              onClick={() => setIndustryImage(!industryImage)}
            >
              <img src={search} alt="search" className="industry-icon" />
            </Box>
          )}
          <Box className="search-box-label" onClick={toggleSidebar}>
            <Box>Industries</Box>
            <Box display="flex" justifyContent="end">
              {isAuthenticatedUser && (
                <Button mr={2} size="xs" onClick={addClientButtonHandler}>
                  +
                </Button>
              )}
            </Box>
          </Box>
        </Box>

        {/* Search box */}
        {!industryImage && (
          <Box
            className="search-box"
            style={{ display: "flex", alignItems: "center" }}
          >
            <Input
              placeholder="Search industry..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <span
              style={{
                position: "absolute",
                right: "6px",
                cursor: "pointer",
              }}
              onClick={() => {
                setSearchText("");
                setIndustryImage(!industryImage);
              }}
            >
              ✕
            </span>
          </Box>
        )}

        {/* Industries + products */}
        <Collapse in={isOpen}>
          <VStack
            p="0px"
            align="start"
            fontSize="14px"
            maxHeight="calc(100vh - 170px)"
            overflow="auto"
          >
            {categoriesLoading ? (
              <Text px="10px" py="5px">
                Loading industries...
              </Text>
            ) : categories.length > 0 ? (
              categories
                .filter((catName) =>
                  catName.toLowerCase().includes(searchText.toLowerCase())
                )
                .map((catName) => (
                  <Box key={catName} w="100%">
                    {/* Industry Row */}
                    <Flex
                      w="100%"
                      p="6px 8px"
                      align="center"
                      justify="space-between"
                      cursor="pointer"
                      bgColor={
                        catName === expandedIndustry ? "rgba(0,0,0,0.05)" : ""
                      }
                      _hover={{ bg: "rgba(0,0,0,0.05)" }}
                      onClick={() => handleIndustryClick(catName)}
                    >
                      <Tooltip label={catName} fontSize="11px">
                        <Text>{catName}</Text>
                      </Tooltip>
                      {catName === expandedIndustry ? (
                        <ChevronUpIcon />
                      ) : (
                        <ChevronDownIcon />
                      )}
                    </Flex>

                    {/* Products under industry */}
                    {catName === expandedIndustry && (
                      <Collapse in={true}>
                        <Box pl="25px" py="6px">
                          {productsLoading ? (
                            <Text fontSize="13px">Loading products...</Text>
                          ) : products && products.length > 0 ? (
                            products.map((prod) => (
                              <Text
                                key={prod._id || prod.sectorDescription}
                                fontSize="13px"
                                py="2px"
                                pl="8px"
                                cursor="pointer"
                                _hover={{ textDecoration: "underline", color: "#2B6CB0" }}
                                onClick={() =>
                                  handleProductClick(prod.sectorDescription)
                                }
                              >
                                {prod.sectorDescription}
                              </Text>
                            ))
                          ) : (
                            <Text fontSize="13px" color="gray.500">
                              No products available
                            </Text>
                          )}
                        </Box>
                      </Collapse>
                    )}
                  </Box>
                ))
            ) : (
              <Text px="10px" py="5px">
                No industries available
              </Text>
            )}
          </VStack>
        </Collapse>
      </VStack>
    </Box>
  );
};

export default LeftSidebar;




// import { useEffect, useState } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate, useParams } from "react-router-dom";
// import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
// import {
//   Box,
//   VStack,
//   Collapse,
//   Button,
//   Tooltip,
//   Input,
//   Text,
//   Flex,
// } from "@chakra-ui/react";
// import { toast } from "react-toastify";
// import { getSectorCategories, getAllSectors } from "../../actions/sector/sectorActions";
// import "./LeftSidebar.scss";
// import search from "../../assets/images/search.png";

// const LeftSidebar = (props) => {
//   const { sectorId } = useParams();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const { isAuthenticatedUser } = useSelector((state) => state.userReducer);

//   const {
//     categories = [], // 6 industries from API
//     categoriesLoading = false,
//     data: products = [], // sectors for selected industry
//     loading: productsLoading = false,
//   } = useSelector((state) => state.sectorSmmReducer);

//   const [industryImage, setIndustryImage] = useState(true);
//   const [searchText, setSearchText] = useState("");
//   const [isOpen, setIsOpen] = useState(true);
//   const [expandedIndustry, setExpandedIndustry] = useState(null);

//   // Debug logging
//   console.log("Categories:", categories);
//   console.log("Products:", products);
//   console.log("Expanded Industry:", expandedIndustry);

//   // fetch industry categories
//   useEffect(() => {
//     dispatch(
// ());
//   }, [dispatch]);

//   // when industry clicked → expand and load sectors
//   const handleIndustryClick = (categoryName) => {
//     console.log("Industry clicked:", categoryName);
//     if (expandedIndustry === categoryName) {
//       setExpandedIndustry(null);
//     } else {
//       setExpandedIndustry(categoryName);
//       dispatch(getAllSectors(categoryName));
//     }
//   };

//   const toggleSidebar = () => setIsOpen(!isOpen);

//   const addClientButtonHandler = () => {
//     toast.error("You will receive an update shortly", { position: "top-center" });
//   };

//   const handleSectorClick = (sectorName, sectorCode) => {
//     if (props.onClose) props.onClose();
//     // Navigate to sector page with name and code
//     navigate(`/sector/${sectorName}?code=${sectorCode}`);
//   };

//   // Get unique SIC2 sectors from products - SIMPLIFIED VERSION
//   const getUniqueSectors = () => {
//     console.log("Getting unique sectors from products:", products);
    
//     if (!products || !Array.isArray(products) || products.length === 0) {
//       console.log("No products found or products is not an array");
//       return [];
//     }
    
//     const uniqueSectors = [];
//     const seenSectors = new Set();
    
//     products.forEach((product, index) => {
//       console.log(`Product ${index}:`, product);
      
//       if (product && product.linkedSIC2) {
//         const sectorKey = `${product.linkedSIC2.code}-${product.linkedSIC2.name}`;
        
//         if (!seenSectors.has(sectorKey)) {
//           seenSectors.add(sectorKey);
//           uniqueSectors.push({
//             id: product.linkedSIC2.id || `sector-${product.linkedSIC2.code}`,
//             name: product.linkedSIC2.name,
//             code: product.linkedSIC2.code
//           });
//         }
//       }
//     });
    
//     console.log("Final unique sectors:", uniqueSectors);
//     return uniqueSectors;
//   };

//   // Render sectors content
//   const renderSectorsContent = () => {
//     if (productsLoading) {
//       return <Text fontSize="13px">Loading sectors...</Text>;
//     }

//     const uniqueSectors = getUniqueSectors();
//     console.log("Rendering sectors:", uniqueSectors);

//     if (uniqueSectors.length === 0) {
//       return (
//         <Text fontSize="13px" color="gray.500">
//           No sectors available
//         </Text>
//       );
//     }

//     return uniqueSectors.map((sector) => (
//       <Text
//         key={sector.id}
//         fontSize="13px"
//         py="2px"
//         pl="8px"
//         cursor="pointer"
//         _hover={{ textDecoration: "underline", color: "#2B6CB0" }}
//         onClick={() => handleSectorClick(sector.name, sector.code)}
//       >
//         {sector.name} ({sector.code})
//       </Text>
//     ));
//   };

//   // Render industries list
//   const renderIndustriesList = () => {
//     if (categoriesLoading) {
//       return (
//         <Text px="10px" py="5px">
//           Loading industries...
//         </Text>
//       );
//     }

//     if (!categories || categories.length === 0) {
//       return (
//         <Text px="10px" py="5px">
//           No industries available
//         </Text>
//       );
//     }

//     const filteredCategories = categories.filter((catName) =>
//       catName.toLowerCase().includes(searchText.toLowerCase())
//     );

//     if (filteredCategories.length === 0) {
//       return (
//         <Text px="10px" py="5px">
//           No industries match your search
//         </Text>
//       );
//     }

//     return filteredCategories.map((catName) => (
//       <Box key={catName} w="100%">
//         {/* Industry Row */}
//         <Flex
//           w="100%"
//           p="6px 8px"
//           align="center"
//           justify="space-between"
//           cursor="pointer"
//           bgColor={
//             catName === expandedIndustry ? "rgba(0,0,0,0.05)" : ""
//           }
//           _hover={{ bg: "rgba(0,0,0,0.05)" }}
//           onClick={() => handleIndustryClick(catName)}
//         >
//           <Tooltip label={catName} fontSize="11px">
//             <Text>{catName}</Text>
//           </Tooltip>
//           {catName === expandedIndustry ? (
//             <ChevronUpIcon />
//           ) : (
//             <ChevronDownIcon />
//           )}
//         </Flex>

//         {/* SIC2 Sectors under industry */}
//         {catName === expandedIndustry && (
//           <Collapse in={true}>
//             <Box pl="25px" py="6px">
//               {renderSectorsContent()}
//             </Box>
//           </Collapse>
//         )}
//       </Box>
//     ));
//   };

//   return (
//     <Box className="left-menu-container">
//       <VStack align="start" className="left-menu">
//         {/* Header */}
//         <Box className="navigation-label-industry search-container">
//           {industryImage && (
//             <Box
//               className="search-box"
//               style={{ cursor: "pointer" }}
//               onClick={() => setIndustryImage(!industryImage)}
//             >
//               <img src={search} alt="search" className="industry-icon" />
//             </Box>
//           )}
//           <Box className="search-box-label" onClick={toggleSidebar}>
//             <Box>Industries</Box>
//             <Box display="flex" justifyContent="end">
//               {isAuthenticatedUser && (
//                 <Button mr={2} size="xs" onClick={addClientButtonHandler}>
//                   +
//                 </Button>
//               )}
//             </Box>
//           </Box>
//         </Box>

//         {/* Search box */}
//         {!industryImage && (
//           <Box
//             className="search-box"
//             style={{ display: "flex", alignItems: "center" }}
//           >
//             <Input
//               placeholder="Search industry..."
//               value={searchText}
//               onChange={(e) => setSearchText(e.target.value)}
//             />
//             <span
//               style={{
//                 position: "absolute",
//                 right: "6px",
//                 cursor: "pointer",
//               }}
//               onClick={() => {
//                 setSearchText("");
//                 setIndustryImage(!industryImage);
//               }}
//             >
//               ✕
//             </span>
//           </Box>
//         )}

//         {/* Industries + sectors */}
//         <Collapse in={isOpen}>
//           <VStack
//             p="0px"
//             align="start"
//             fontSize="14px"
//             maxHeight="calc(100vh - 170px)"
//             overflow="auto"
//           >
//             {renderIndustriesList()}
//           </VStack>
//         </Collapse>
//       </VStack>
//     </Box>
//   );
// };

// export default LeftSidebar;








